const COMMAS_DISPLAY_NAME = 'ScaleGG Pay';

const COMMAS_FIELDS = [
  {
    key: 'api_key',
    label: 'API Key',
    info: 'Use a ScaleGG Pay sandbox key while testing.',
    defaultValue: ''
  },
  {
    key: 'creator_id',
    label: 'Creator Slug',
    info: 'Enter the creator slug supplied for this ScaleGG Pay account.',
    defaultValue: ''
  },
  {
    key: 'environment',
    label: 'Environment',
    info: 'Test and QA keys use sandbox; live keys use production.',
    defaultValue: 'sandbox'
  }
];

function normalizeCommasEnvironment(value) {
  const environment = String(value || '').trim().toLowerCase();

  if (['sandbox', 'test', 'testing', 'qa'].includes(environment)) {
    return 'sandbox';
  }

  if (['production', 'prod', 'live'].includes(environment)) {
    return 'production';
  }

  return environment;
}

function prepareCommasFields(fields) {
  const currentFields = Array.isArray(fields) ? fields : [];
  const currentByKey = currentFields.reduce((result, field) => {
    if (field && field.key) result[field.key] = field;
    return result;
  }, {});

  return COMMAS_FIELDS.map((definition) => {
    const current = currentByKey[definition.key] || {};
    const currentValue = current.value;
    const value =
      currentValue === undefined || currentValue === null || currentValue === ''
        ? definition.defaultValue
        : currentValue;

    return {
      ...current,
      key: definition.key,
      label: definition.label,
      info: definition.info,
      value:
        definition.key === 'environment'
          ? normalizeCommasEnvironment(value)
          : value
    };
  });
}

function commasDetailsFromFields(fields) {
  const preparedFields = prepareCommasFields(fields);

  return preparedFields.reduce((details, field) => {
    const value = String(field.value || '').trim();
    details[field.key] =
      field.key === 'environment'
        ? normalizeCommasEnvironment(value)
        : value;
    return details;
  }, {});
}

module.exports = {
  COMMAS_DISPLAY_NAME,
  commasDetailsFromFields,
  normalizeCommasEnvironment,
  prepareCommasFields
};
